import React, { useContext, useEffect, useState } from "react";
import { Button, Grid, IconButton, makeStyles, Paper } from "@material-ui/core";
import { Col, Div, H6, Row, TextInput } from "qdm-component-library";
import { AlertProps } from "../../../utils";
import { AlertContext, EnvContext } from "../../../contexts";
import deleteicon from "../../../assets/icons8-trash.svg";
import { CommonTabList } from "../../../components";
import EditIcon from "@material-ui/icons/CreateOutlined";
import moment from "moment";
import { CreateRule } from "rulebuilder-v1";
import { useDispatch } from "react-redux";
import { actions } from "primary_care_admin_binder";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  addBtn: {
    float: "right",
    fontSize: "14px",
    fontWeight: 600,
  },
  content: {
    width: "100%",
    height: "calc(100vh - 64px)",
    overflow: "auto",
    [theme.breakpoints.up("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    marginTop: "70px",
    marginLeft: "0px",
    marginRight: "0px",
  },
  topNavbar: {},
  sideNavbar: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hovarNavBar: {
    display: "flex",
    position: "relative",
    top: "63px",
  },
  commanTabbar: {
    display: "flex",
    position: "relative",
    top: "70px",
    marginLeft: "80px",
  },
  ".MuiSvgIcon-root": {
    display: "none",
  },
}));

const RevenueTargetScreen = ({
  formConnect,
  formRows,
  setFormRows,
  setFormConnect,
  ...props
}) => {
  const classes = useStyles();
  const [formError, setformError] = React.useState(false);
  const alert = useContext(AlertContext);
  const { envConfig } = useContext(EnvContext);

  const [ruleRowIndex, setRuleRowIndex] = useState(0);
  const getUtcTime = (date) => {
    if (date) {
      return moment.utc(date).unix();
    } else {
      return moment.utc().unix();
    }
  };

  const [RuleModalOpen, setRuleModalOpen] = useState({
    isIncCriteria: false,
    editId: "",
  });

  const saveRule = (data) => {
    const updatedRows = [...formRows];
    updatedRows[ruleRowIndex].creteria = data || "";
    setFormRows(updatedRows);
    setRuleModalOpen({ ...RuleModalOpen, isIncCriteria: false });
    setRuleRowIndex(null);
  };
  useEffect(() => {
    if (props?.isFormOpen?.isEdit) {
      setFormConnect({
        targetcode: props?.editValue?.targetcode,
        targetname: props?.editValue?.targetname,
        targetfrom: props?.editValue?.targetfrom,
        targettill: props?.editValue?.targettill,
        targetvalue: props?.editValue?.targetvalue,
        editId: props?.editValue?.editId,
      });
      setFormRows(props?.editValue?.headerparams);
    }
  }, [props?.editValue]);

  const handleChange = (key, value) => {
    setFormConnect({
      ...formConnect,
      targetcode: "",
      targetname: "",
      targetfrom: "",
      targettill: "",
      targetvalue: "",
      creteria: "",
      target: "",
    });
    setFormConnect({
      ...formConnect,
      [key]: value,
    });
  };

  const [perPage, setPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [searchname, setsearchname] = React.useState(0);

  const onSave = async () => {
    if (!formConnect?.targetname || !formConnect?.targetvalue) {
      setformError(true);
      alert?.setSnack({
        open: true,
        severity: AlertProps.severity.error,
        msg: "Please fill in the mandatory fields...",
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.right,
        tone: true,
      });
      return;
    }
    const headerparam = formRows.map((item) => ({
      creteria: item?.creteria?._id,
      target: parseInt(item?.target),
    }));
    const payloadData = {
      _id: formConnect.editId ?? "",
      targetcode: formConnect.targetcode,
      targetname: formConnect.targetname,
      targetfrom: getUtcTime(moment(formConnect.targetfrom)),
      targettill: getUtcTime(moment(formConnect.targettill)),
      targetvalue: parseInt(formConnect.targetvalue),
      targetdetails: headerparam,
    };
    const getJwtToken = localStorage.getItem("token");

    const payload = {
      data: payloadData,
      jwtToken: getJwtToken,
    };

    const targetNameValid = await dispatch(
      actions.TARGET_NAME_VALIDATION(formConnect.targetname)
    );
    if (targetNameValid?.payload?.data?.length > 0) {
      const duplicateFound = targetNameValid.payload.data.some(
        (item) =>
          item.targetname === formConnect.targetname &&
          item._id !== formConnect.editId
      );

      if (duplicateFound) {
        setformError(true);
        alert?.setSnack({
          open: true,
          severity: AlertProps.severity.error,
          msg: "Target Name already exists",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.right,
          tone: true,
        });
        return;
      }
    }

    const readTargetRevenue = await dispatch(
      actions.TARGET_REVENUE_UPSERT({ payload, editId: formConnect.editId })
    );
    const readTarget = await dispatch(
      actions.TARGET_REVENUE_READ({
        searchname: "",
        page: page ?? 0,
        perPage: perPage ?? 10,
      })
    );
    setformError(true);
    alert?.setSnack({
      open: true,
      severity: AlertProps.severity.success,
      msg: `${
        props?.RevenueTargetScreen?._id
          ? `Saved Successfully! ID: ${props?.RevenueTargetScreen?._id}`
          : "Saved Successfully!"
      }`,
      vertical: AlertProps.vertical.top,
      horizontal: AlertProps.horizontal.right,
      tone: true,
    });

    props.setisFormOpen({
      isView: false,
      isEdit: false,
      isForm: false,
    });
  };

  const handleAddRow = () => {
    const newRow = { creteria: "", target: 0 };
    const newRows = [...formRows, newRow];
    setFormRows(newRows);

    // Set the index of the new row
    setRuleRowIndex(newRows.length - 1);
    setRuleModalOpen({ ...RuleModalOpen, editId: "" });
  };

  const handleChangeRow = (index, field, value) => {
    const updatedRows = [...formRows];
    updatedRows[index][field] = value;
    setFormRows(updatedRows);
  };

  const handleDeleteRow = (index) => {
    const updatedFormRows = [...formRows];
    updatedFormRows.splice(index, 1);
    setFormRows(updatedFormRows);
  };

  const onCancel = () => {
    props.setisFormOpen(false);
    setFormConnect({
      targetcode: "",
      targetname: "",
      targetfrom: "",
      targettill: "",
      targetvalue: "",
    });
    setFormRows([]);
  };

  const handleEdit = (data, index) => {
    setRuleModalOpen({
      ...RuleModalOpen,
      isIncCriteria: true,
      editId: data?.creteria?._id,
    });
    setRuleRowIndex(index);
  };

  const dispatch = useDispatch();

  const { parent_id, closeForm, editData, isView, getReferralType } = props;
  return (
    <React.Fragment>
      <CommonTabList
        parent_id={"admintabpanel"}
        title="Target Revenue"
        list={[]}
        backbtn={true}
        backFun={() => {
          props?.setisFormOpen({
            ...props?.isFormOpen,
            isForm: false,
            isView: false,
            isEdit: false,
          });
        }}
      />
      <Div
        id={`${parent_id}-parent-div`}
        className="pi-root"
        style={{ margin: "20px" }}
      >
        <Paper>
          <Div style={{ padding: "15px" }}>
            <Div>
              <Grid container spacing={2} direction="column">
                <Grid item>
                  <Div>
                    <Row>
                      <Col
                        md={2}
                        lg={2}
                        sm={6}
                        xs={12}
                        inLineStyles={{ padding: 10 }}
                      >
                        <TextInput
                          label={
                            <>
                              Code<span style={{ color: "red" }}> *</span>
                            </>
                          }
                          name="targetcode"
                          value={formConnect?.targetcode}
                          placeholder=""
                          onChange={(e, v) => {
                            if (/^[0-9a-zA-Z-]*$/.test(e.target.value)) {
                              handleChange("targetcode", e.target.value);
                            }
                          }}
                          disabled
                          error={formError && !formConnect?.targetcode}
                        />
                      </Col>
                      <Col
                        md={2}
                        lg={2}
                        sm={6}
                        xs={12}
                        inLineStyles={{ padding: 10 }}
                      >
                        <TextInput
                          label={
                            <>
                              Target Name
                              <span style={{ color: "red" }}> *</span>
                            </>
                          }
                          name="targetname"
                          value={formConnect?.targetname}
                          placeholder="Enter Target Name"
                          onChange={(e, v) => {
                            handleChange("targetname", e.target.value);
                          }}
                          disabled={props?.isFormOpen?.isView}
                          error={formError && !formConnect?.targetname}
                          required={true}
                        />
                      </Col>
                      <Col
                        md={2}
                        lg={2}
                        sm={6}
                        xs={12}
                        inLineStyles={{ padding: 10 }}
                      >
                        <TextInput
                          label={
                            <>
                              From Date<span style={{ color: "red" }}> *</span>
                            </>
                          }
                          name="targetfrom"
                          value={
                            formConnect?.targetfrom
                              ? moment(formConnect?.targetfrom).format(
                                  "YYYY-MM-DD"
                                )
                              : ""
                          }
                          onChange={(e, v) => {
                            handleChange("targetfrom", e.target.value);
                          }}
                          disabled={props?.isFormOpen?.isView}
                          error={formError && !formConnect?.targetfrom}
                          type="date"
                          required={true}
                        />
                      </Col>
                      <Col
                        md={2}
                        lg={2}
                        sm={6}
                        xs={12}
                        inLineStyles={{ padding: 10 }}
                      >
                        <TextInput
                          label={
                            <>
                              Till Date<span style={{ color: "red" }}> *</span>
                            </>
                          }
                          name="targettill"
                          value={
                            formConnect?.targettill
                              ? moment(formConnect?.targettill).format(
                                  "YYYY-MM-DD"
                                )
                              : ""
                          }
                          onChange={(e, v) => {
                            handleChange("targettill", e.target.value);
                          }}
                          disabled={props?.isFormOpen?.isView}
                          error={formError && !formConnect?.targettill}
                          type="date"
                          required={true}
                          min={moment(formConnect?.targetfrom).format(
                            "YYYY-MM-DD"
                          )}
                        />
                      </Col>
                      <Col
                        md={2}
                        lg={2}
                        sm={6}
                        xs={12}
                        inLineStyles={{ padding: 10 }}
                      >
                        <TextInput
                          label={
                            <>
                              Target (INR)
                              <span style={{ color: "red" }}> *</span>
                            </>
                          }
                          name="targetvalue"
                          value={formConnect?.targetvalue}
                          placeholder="Enter Target INR"
                          onChange={(e, v) => {
                            handleChange("targetvalue", e.target.value);
                          }}
                          disabled={props?.isFormOpen?.isView}
                          error={formError && !formConnect?.targetvalue}
                          type="number"
                          required={true}
                        />
                      </Col>
                    </Row>
                  </Div>
                </Grid>
              </Grid>
            </Div>
          </Div>
        </Paper>
      </Div>

      <Div
        id={`${parent_id}-parent-div`}
        className="pi-root"
        style={{ margin: "20px" }}
      >
        <Paper>
          <Div style={{ padding: "15px" }}>
            <Div>
              <Grid container spacing={2} direction="column">
                <Grid item>
                  <Paper>
                    <Div>
                      <Div>
                        <Row>
                          <Col
                            md={2}
                            lg={2}
                            sm={6}
                            xs={12}
                            inLineStyles={{ padding: 10 }}
                          >
                            <H6
                              className="pi-title"
                              style={{ fontSize: "26px" }}
                            >
                              {"Inclusion Criteria"}
                            </H6>
                          </Col>
                          <Col lg={10}>
                            <Button
                              className={classes.addBtn}
                              color="primary"
                              onClick={handleAddRow}
                              hidden={props?.isFormOpen?.isView}
                            >
                              + Add New
                            </Button>
                          </Col>
                        </Row>

                        {formRows.map((row, index) => (
                          <Row key={index}>
                            {row?.creteria?._id ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: 8,
                                  }}
                                >
                                  <Col
                                    lg={8}
                                    sm={2}
                                    xs={6}
                                    inLineStyles={{ padding: 8 }}
                                  >
                                    <span>
                                      {"Rule Name : " + row.creteria.ruleName}
                                    </span>
                                  </Col>
                                  <IconButton
                                    aria-label="EditIcon"
                                    className={classes.margin}
                                    size="small"
                                    onClick={() => handleEdit(row, index)}
                                    style={{ marginLeft: 62 }}
                                    hidden={props?.isFormOpen?.isView}
                                  >
                                    <EditIcon
                                      style={{ color: "#0071F2", fontSize: 18 }}
                                    />
                                  </IconButton>
                                </div>
                                <div className={classes.dot} />
                              </>
                            ) : (
                              <Col
                                md={2}
                                lg={2}
                                sm={6}
                                xs={12}
                                inLineStyles={{ padding: 10 }}
                              >
                                Criteria
                                <Button
                                  style={{ padding: 7, width: 234 }}
                                  variant="outlined"
                                  color="secondary"
                                  onClick={() =>
                                    setRuleModalOpen({
                                      ...RuleModalOpen,
                                      isIncCriteria: true,
                                    })
                                  }
                                >
                                  + Add New Rule
                                </Button>
                              </Col>
                            )}
                            <Col
                              md={2}
                              lg={2}
                              sm={6}
                              xs={12}
                              inLineStyles={{ padding: 10 }}
                            >
                              <TextInput
                                label="Target (Inr)"
                                name="target"
                                value={row.target}
                                onChange={(e) =>
                                  handleChangeRow(
                                    index,
                                    "target",
                                    e.target.value
                                  )
                                }
                                disabled={props?.isFormOpen?.isView}
                                type="number"
                                placeholder="Enter Target INR"
                                required
                              />
                            </Col>
                            <Col lg={2}>
                              <div
                                style={{ marginTop: "40px" }}
                                onClick={() => handleDeleteRow(index)}
                                hidden={props?.isFormOpen?.isView}
                              >
                                <img src={deleteicon} alt="Icon" />
                              </div>
                            </Col>
                          </Row>
                        ))}
                      </Div>
                    </Div>
                  </Paper>
                </Grid>
              </Grid>
            </Div>
          </Div>
        </Paper>
      </Div>

      <Grid id={"agerange-form-rangedetails-grid"} style={{ padding: "30px" }}>
        <Button
          id={"agerange_form_rangedetails_Save_button"}
          style={{ float: "right" }}
          variant="contained"
          color="primary"
          onClick={onSave}
          hidden={props?.isFormOpen?.isView}
        >
          {props?.editValue?.length ? "Update" : "Save"}
        </Button>
        <Button
          id={"agerange_form_rangedetails_Cancel_button"}
          style={{ float: "right", marginRight: "20px" }}
          variant="outlined"
          onClick={onCancel}
        >
          Cancel
        </Button>
      </Grid>

      {RuleModalOpen?.isIncCriteria && (
        <div>
          <CreateRule
            alert={alert}
            savedRuleData={(data) => {
              saveRule(data);
              setRuleModalOpen({ ...RuleModalOpen, isIncCriteria: false });
            }}
            handleClose={() =>
              setRuleModalOpen({ ...RuleModalOpen, isIncCriteria: false })
            }
            open={RuleModalOpen?.isIncCriteria}
            dbName={envConfig.REACT_APP_DATABASE_NAME}
            factId={"factsdefinition/10087"}
            ruleId={RuleModalOpen?.editId}
            metadataId={envConfig.REACT_APP_METADATAID}
            metadata_dbname={envConfig.REACT_APP_METADATA_DB_NAME}
            rulesParams={{
              tenantId: envConfig.REACT_APP_TENANTID,
              facilityId: envConfig.REACT_APP_FACILITY_ID,
            }}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default RevenueTargetScreen;
